
import { PureComponent } from 'react';

import { isLocalParticipantModerator } from '../../base/participants';
import { showNotification } from '../../notifications';
import { setKnockingParticipantApproval } from '../actions';

declare var config: object;

export type Props = {

    /**
     * The list of participants.
     */
    _participants: Array<Object>,

    /**
     * True if the list should be rendered.
     */
    _visible: boolean,

    /**
     * The Redux Dispatch function.
     */
    dispatch: Function,

    /**
     * Function to be used to translate i18n labels.
     */
    t: Function
};

/**
 * Abstract class to encapsulate the platform common code of the {@code KnockingParticipantList}.
 */
export default class AbstractKnockingParticipantList<P: Props = Props> extends PureComponent<P> {
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props: P) {
        super(props);

        this._onRespondToParticipant = this._onRespondToParticipant.bind(this);
    }

    _onRespondToParticipant: (string, boolean) => Function;

    /**
     * Function that constructs a callback for the response handler button.
     *
     * @param {string} id - The id of the knocking participant.
     * @param {boolean} approve - The response for the knocking.
     * @returns {Function}
     */
    _onRespondToParticipant(id, approve) {
        const availableSlots = this.props.participantAllowedinMeeting - this.props._participantsinConference.length;

        if (!approve) {
            return () => {
                this.props.dispatch(setKnockingParticipantApproval(id, approve));
            };
        }

        if (approve && availableSlots > 0) {
            return () => {
                this.props.dispatch(setKnockingParticipantApproval(id, approve));
            };
        }

        if (approve) {
            return () => {

                this.props.dispatch(showNotification({
                    descriptionArguments: { number: this.props.participantAllowedinMeeting },
                    descriptionKey: 'notify.participantLimitReachedDes',
                    titleKey: 'notify.participantLimitReached',
                    customActionNameKey: 'notify.upgradeNow',
                    customActionHandler: () => window.open(`${config?.URL_PREFIX}updateSubscription`, '_new')
                }));
            };
        }


    }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
export function mapStateToProps(state: Object): $Shape<Props> {
    const { knockingParticipants, lobbyEnabled } = state['features/lobby'];
    const participants = state['features/base/participants'];
    const conference = state['features/base/conference'].conference;

    const participantAllowedinMeeting = state['features/base/jwt']?.meetingDetails?.max_participants;

    return {
        _knockingParticipants: knockingParticipants,
        _visible: lobbyEnabled && isLocalParticipantModerator(state) && Boolean(knockingParticipants.length),
        _participantsinConference: participants,
        participantAllowedinMeeting,
        conference
    };
}
